<template>
  <button
    type="button"
    class="pamia-fab position-fixed rounded-circle border-0 bg-white text-white d-flex align-items-center justify-content-center"
    aria-label="Falar com a Pamia"
    @click="openModal"
  >
    <!-- <i class="fa-solid fa-face-smile fa-lg"></i> -->
    <img src="@/assets/img/pamia.png" alt="" height="35" />
  </button>

  <ModalComponent
    id="pamia-modal"
    :backdrop="'true'"
    modalClass="pamia-modal"
    modalDialogClass="pamia-modal-dialog"
    modalBodyClass="p-0 d-flex flex-column"
    @modalClosed="handleModalClosed"
  >
    <template v-slot:body>
      <LoadingContainer v-if="loadingUrl" />
      <iframe
        v-else-if="iframeUrl"
        :src="iframeUrl"
        frameborder="0"
        class="flex-fill w-100 border-0"
      ></iframe>
    </template>
  </ModalComponent>
</template>

<script>
import { useMainStore } from "@/store";
import { storeToRefs } from "pinia";
import { toggleModal } from "./ModalComponent.vue";

export default {
  name: "PamiaWidget",
  setup() {
    const store = useMainStore();
    const { session } = storeToRefs(store);
    return { userSession: session };
  },
  data() {
    return {
      iframeUrl: "",
      loadingUrl: true,
    };
  },
  methods: {
    openModal() {
      toggleModal("pamia-modal");
      this.loadUrl();
    },
    handleModalClosed() {
      this.iframeUrl = "";
    },
    async loadUrl() {
      this.loadingUrl = true;
      this.iframeUrl = "";
      if (this.userSession) {
        try {
          const res = await this.$pamiaService.getWebviewUrl();
          this.iframeUrl = res.data.url;
        } catch (e) {
          this.$eventBus.$emit("showErrorToast", {
            msg:
              e?.message || "Não foi possível abrir a Pamia, tente novamente",
          });
        } finally {
          this.loadingUrl = false;
        }
        return;
      }
      this.iframeUrl = `${process.env.VUE_APP_API_BASE_URL}pamia`;
      this.loadingUrl = false;
    },
  },
};
</script>

<style scoped>
.pamia-fab {
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  z-index: 1030;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}
</style>

<!--
  ModalComponent has multiple root nodes (the .modal div + a hidden trigger button),
  so Vue can't forward this component's scope attribute onto it for `:deep()` to reach.
  These rules target it by its unique #pamia-modal id instead, unscoped.
-->
<style>
#pamia-modal .modal-dialog {
  max-width: 420px !important;
  height: 85vh !important;
}

#pamia-modal .modal-content {
  height: 100% !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

#pamia-modal .modal-header {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  z-index: 2 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

#pamia-modal .modal-header i {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  background: #123766 !important;
  color: #fff !important;
  font-size: 14px !important;
  position: absolute;
  top: -20px;
  right: -20px;
}

#pamia-modal .modal-body {
  height: 100% !important;
  overflow: hidden !important;
  border-radius: 1rem;
  background-color: #fff;
  justify-content: center;
}
</style>
